<h1 class="header">Are you still there?</h1>
<div>
  <div class="content">
    For your security, we’ll log you out soon due to inactivity. Stay signed in
    by confirming you're still here.
  </div>
  <div class="timer-block">
    <div class="timer-content">
      <img src="assets/remained-time-icon.svg" />
      Your online session will expire in
    </div>
    <div class="timer">{{ remainedTime }}</div>
  </div>
</div>
<div mat-dialog-actions class="action-modal-logout">
  <button
    mat-flat-button
    color="secondary"
    class="approve-without-match"
    type="button"
    [mat-dialog-close]="closeModalEvent">
    Log out
  </button>
  <button
    mat-flat-button
    color="primary"
    class="submit-btn"
    type="button"
    mat-dialog-close>
    Resume session
  </button>
</div>
